var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarkWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.894,
    height: 16.248,
    viewBox: "0 0 18.894 16.248",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_23341",
    "data-name": "Group 23341",
    transform: "translate(-712.553 -159.234)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "danger",
    transform: "translate(712.553 123.377)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23328",
    "data-name": "Group 23328",
    transform: "translate(0 35.857)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23327",
    "data-name": "Group 23327",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3918",
    "data-name": "Path 3918",
    d: "M18.651,49.531,10.9,36.678a1.7,1.7,0,0,0-2.907,0L.243,49.531A1.7,1.7,0,0,0,1.7,52.1H17.2a1.7,1.7,0,0,0,1.454-2.574ZM17.6,50.637a.468.468,0,0,1-.407.238H1.7a.467.467,0,0,1-.4-.709l7.75-12.853a.467.467,0,0,1,.8,0L17.6,50.166A.468.468,0,0,1,17.6,50.637Z",
    transform: "translate(0 -35.857)",
    fill: "#f4906a"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_23340",
    "data-name": "Group 23340",
    transform: "translate(721.335 164.025)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3915",
    "data-name": "Path 3915",
    d: "M234.327,84.338c-.367,0-.664.214-.664.477v4.774c0,.264.3.477.664.477s.664-.214.664-.477V84.815C234.992,84.552,234.694,84.338,234.327,84.338Z",
    transform: "translate(-233.663 -84.338)",
    fill: "#f4906a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3916",
    "data-name": "Path 3916",
    d: "M234.327,383a.664.664,0,1,0,.664.664A.665.665,0,0,0,234.327,383Z",
    transform: "translate(-233.663 -375.947)",
    fill: "#f4906a"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkWarning);
export default __webpack_public_path__ + "static/media/mark_warning.8410e58516bf36f44effed47033447af.svg";
export { ForwardRef as ReactComponent };